var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name !== 'Login')?_c('Header'):_vm._e(),_c('router-view',{key:_vm.$route.fullPath}),_c('div',{staticClass:"loader-container",class:{ loading: _vm.getLoading }},[_c('div',{staticClass:"loader"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }